import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=8cf03fd8&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"
import style0 from "./reg.vue?vue&type=style&index=0&id=8cf03fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf03fd8",
  null
  
)

export default component.exports